/**
 * Class, providing backwards compatibility for the original urls of the site (such as bio.pho?band_id=666)
 * @class OriginalUrlsSupport
 */

class OriginalUrlsSupport {
  constructor () {
    this.location = window.location
    this.pages = [
      'index.php', // /
      'album.php', // /albums/:id
      'alphabetical.php', // /alphanumeric/:letter
      'artist.php', // /artists/:id
      'catalog.php', // /labels/:label
      'genres.php', // /genres/:genre
      'years.php', // /years/:range
      'states.php', // /regions
      'state.php', // /regions/:region
      'releases.php', // /releases/:format
      'help.php', // help/
      'bio.php', // bands/:id
      'members.php', // bands/:id
      'discography.php' // bands/:id
    ]
  }
  /**
   * Initialize the class
   * @method init
   * @return {void}
   */
  init () {
    this.parseUrl()
  }
  /**
   * Parse the url and get the query parameters as an object
   * @method parseUrl
   * @return {void}
   */
  parseUrl () {
    const querySplit = this.location.href.split('?')
    const query = querySplit[1] ? querySplit[1].split('&') : []
    const params = {}
    if (query.length) {
      query.forEach(parameter => {
        parameter = parameter.split('=')
        params[parameter[0]] = parameter[1]
      })
    }
    this.location.params = params
    this.checkPage()
  }
  /**
   * Check if the URL contains a string
   * @method hrefContains
   * @params {string} string [string='']
   * @return {boolean}
   */
  hrefContains (string = '') {
    return this.location.href.includes(string)
  }
  /**
   * Check the page and do the necessary reloads to the new location
   * @method checkPage
   * @return {void}
   */
  checkPage () {
    const location = this.location
    const params = location.params
    const path = location.pathname.split('/')[1]
    if (this.pages.includes(path) && Object.keys(params).length) {
      switch (path.split('.')[0]) {
        case 'alphabetical':
          this.goTo('/alphanumeric/' + decodeURIComponent(params.letter))
          break
        case 'genres':
          this.goTo('/genres/' + decodeURIComponent(params.gnr))
          break
        case 'album':
          this.goTo('/albums/' + decodeURIComponent(params.d_id))
          break
        case 'artist':
          this.goTo('/artists/' + decodeURIComponent(params.artist_id))
          break
        case 'years':
          this.goTo('/years/' + decodeURIComponent(params.yrs))
          break
        case 'catalog':
          this.goTo('/labels/' + decodeURIComponent(params.label))
          break
        case 'state':
          this.goTo('/regions/' + decodeURIComponent(params.st))
          break
        case 'releases':
          this.goTo('/releases/' + decodeURIComponent(params.format))
          break
        case 'bio':
        case 'members':
        case 'discography':
          this.goTo('/bands/' + decodeURIComponent(params.band_id))
          break
      }
    } else {
      if (path !== '') {
        switch (path) {
          case 'help.php':
            this.goTo('/help')
            break
          case 'index.php':
            this.goTo('/')
            break
          case 'album.php':
            this.goTo('/albums')
            break
          case 'artist.php':
            this.goTo('/artists')
            break
          case 'genres.php':
            this.goTo('/genres')
            break
          case 'catalog.php':
            this.goTo('/labels')
            break
          case 'states.php':
            this.goTo('/regions')
            break
          case 'releases.php':
            this.goTo('/releases')
            break
          case 'years.php':
            this.goTo('/years')
            break
          case 'bio.php':
          case 'members.php':
          case 'discography.php':
            this.goTo('/bands')
            break
        }
      }
    }
  }

  /**
   * Reload the page with the new location
   * @method goTo
   * @return {void}
   */
  goTo (location) {
    window.location.replace(location)
  }
}

export default OriginalUrlsSupport



// WEBPACK FOOTER //
// ./src/helpers/original-urls-support.js